import {
  PaginationIntent,
  PaginationRequest,
  PaginationRequestSchema,
} from "@/gen/ts/v1/common/pagination_pb";
import { ListAttendeesRequest_SortField } from "@/gen/ts/v1/event/event_requests_pb";
import { create } from "@bufbuild/protobuf";
import { createQueryKeys } from "@lukemorales/query-key-factory";
import { getRegistrationStatus, listAttendees } from "./attendees.client";

export const events = createQueryKeys("events", {
  attendees: ({
    eventId,
    pagination = create(PaginationRequestSchema, {
      limit: 50,
      intent: PaginationIntent.FIRST,
    }),
    sortBy = ListAttendeesRequest_SortField.CREATED_AT,
    sortDescending = true,
  }: {
    eventId: string;
    pagination?: PaginationRequest;
    sortBy?: ListAttendeesRequest_SortField;
    sortDescending?: boolean;
  }) => ({
    queryKey: [eventId, { pagination, sortBy, sortDescending }],
    queryFn: () =>
      listAttendees({
        eventId,
        pagination,
        sortBy,
        sortDescending,
      }),
  }),
  registrationStatus: ({ eventId }: { eventId: string }) => ({
    queryKey: ["registration-status", eventId],
    queryFn: () => getRegistrationStatus({ eventId }),
  }),
});
